import { AxiosResponse, isAxiosError } from 'axios'
import { Experiments, chowlyApi } from 'config'

import client from '../chowly'

export const getFeatureFlags = async () => {
  const url = chowlyApi.experimentAccess
  const experimentValues = Object.values(Experiments)

  const payload = {
    experiments: experimentValues,
  }

  let response: AxiosResponse | undefined
  try {
    response = await client.post(url, payload, { timeout: 5000 }) // 5s timeout since this endpoint often hangs
  } catch (err: unknown) {
    if (isAxiosError(err) && err.code === 'ECONNABORTED') {
      console.log('Request timed out while fetching feature flags.')
    } else {
      console.log('Error fetching feature flags:', err)
    }
  }

  return response?.data?.experiments
}
